import React from "react";
import {Checkbox, FormControlLabel} from "@mui/material";
import {Svg} from "assets";

export const CheckboxMain = ({
                                 checked,
                                 onChange,
                                 className,
                                 label,
                                 disabled,
                                 value
                             }) => {
    return (
        <div className={`checkbox-box ${className ? className : ""}`}>
            <FormControlLabel
                value={value}
                label={label}
                disabled={disabled}
                control={
                    <Checkbox
                        checked={checked}
                        onChange={onChange}
                        icon={<Svg.CheckboxSvg/>}
                        checkedIcon={<Svg.CheckboxCheckedSvg/>}
                    />
                }
            />
        </div>
    );
};
